'use client';
import { Filter } from '@/components/atoms/Display';
import styles from './filtertable.module.scss';
import { useState } from 'react';
import { Option, OptionGroup, Select } from '@/ui-components/atoms/Inputs/Select';
export interface Item {
    name: string;
    details: string;
}

export interface DataGroups {
    [key: string]: string[];
}

interface FilterTableProps {
    dataGroups: DataGroups;
    dataList: Item[];
    defaultFilter: string;
    headers: string[];
}

export default function FilterTable({
    dataGroups,
    dataList,
    defaultFilter,
    headers,
}: FilterTableProps): React.JSX.Element {
    const [selectedFilter, setSelectedFilter] = useState<string>(defaultFilter);

    const isInSelectedGroup = (areaName: string, selectedFilter: string) => {
        const selectedGroup = dataGroups[selectedFilter];
        return selectedGroup ? selectedGroup.includes(areaName) : false;
    };

    return (
        <>
            <Select
                label="Select"
                type="bar"
                theme="outline"
                name="select"
                value={selectedFilter}
                placeholder={selectedFilter}
                onChange={(element: HTMLInputElement, { value }: { value: string }) => setSelectedFilter(value)}
            >
                <OptionGroup>
                    {Object.keys(dataGroups).map((group, i) => (
                        <Option key={i} value={group}>
                            {group}
                        </Option>
                    ))}
                </OptionGroup>
            </Select>

            <table className={styles.filterTable}>
                <thead>
                    <tr>
                        {headers.map((header, i) => (
                            <th key={i}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataList.map((item, i) => (
                        <Filter
                            key={i}
                            conditions={{ item: { type: 'exact', value: item.name } }}
                            criteria={{ item: isInSelectedGroup(item.name, selectedFilter) ? item.name : '' }}
                        >
                            <tr>
                                <td>{item.name}</td>
                                <td>{item.details}</td>
                            </tr>
                        </Filter>
                    ))}
                </tbody>
            </table>
        </>
    );
}
